import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/knowledge-center")({
  component: () => <Outlet />,
});
